import {lazyComponent} from 'coreUtils/adapters/lazy';

const WishlistFlyout = lazyComponent(() => import('./WishlistFlyout'));

export {WishlistFlyout as default};
